<template>
    <div>
        <b-card no-body>
            <b-overlay class="p-1" :show="loading" opacity="0.2" rounded="sm">
                <div class="d-flex">
                    <flat-pickr v-model="dateRange" class="form-control" :config="{altInput:true, altFormat:'d.m.Y', dateFormat: 'Y-m-d',mode:'range', locale:'tr'}" placeholder="Tarih Aralığı Seçiniz"/>
                    <button class="btn btn-primary ml-1" :disabled="!c_dates.StartDate || !c_dates.EndDate" v-on:click="getStatsSummary">Raporla</button>
                </div>
            </b-overlay>
        </b-card>
        <b-card no-body>
            <h4 class="pr-2 pl-2 pt-2 pb-50">Tarih Aralığına Göre Özet Bilgiler</h4>
            <v-table    ref="table"
                        with-items
                        :items="summary"
                        name="narli-ferry-stats"
                        :settings="false"
                        :fields="fields"></v-table>
            <div class="p-2">
                <narli-ferryboat-stats-by-vehicle-type-summary-graph :summary="summary"></narli-ferryboat-stats-by-vehicle-type-summary-graph>
            </div>
        </b-card>
    </div>
</template>

<script>
import { BCard,BOverlay } from "bootstrap-vue";
import flatPickr from 'vue-flatpickr-component'
import ReportsApi from "@/api/reports";
import 'flatpickr/dist/l10n/tr.js' 
import NarliFerryboatStatsByVehicleTypeSummaryGraph from "@/views/reports/narli-ferryboat/components/NarliFerryboatStatsByVehicleTypeSummaryGraph.vue";
import moment from "moment";
export default {
    components:{
        BCard,
        BOverlay,
        flatPickr,
        NarliFerryboatStatsByVehicleTypeSummaryGraph,
    },
    mounted(){
        this.dateRange = this.c_month
        this.getStatsSummary()
    },
    data() {
        return {
            dateRange:null,
            loading:false,
            summary:[],
            fields:[
                {name:"Tip",key:"Type"},
                {name:"Toplam Fiyat (TL) (VD)",key:"TotalAmount" ,tooltip:"Vergi Dahil"},
                {name:"Toplam Fiyat (TL) (VH)",key:"TotalAmountWithoutTax" ,tooltip:"Vergi Hariç"},
                {name:"Toplam Geçis Sayısı",key:"TotalCount" },
                {name:"Ortalama Fiyat (TL) (VD)",key:"AvgAmount", tooltip:"Vergi Dahil"},
                {name:"Ortalama Fiyat (TL) (VH)",key:"AvgAmountWithoutTax", tooltip:"Vergi Hariç"},
            ]
        }
    },
    methods:{
        getStatsSummary(){
            if(this.c_dates.StartDate && this.c_dates.EndDate){
                this.loading = true
                let data = {StartDate:this.c_dates.StartDate,EndDate:this.c_dates.EndDate}
                ReportsApi.NarliFerryboat.TableSummary(data).then(res=>{
                    if(res.data.Success){
                        this.summary = res.data.Data
                    }
                    this$result(res)
                    this.loading = false
                }).catch(err=>{
                    this.loading = false
                })
            }
        }
    },
    computed:{
        c_dates(){
            return {
                StartDate : this.dateRange?.split(' - ')[0] || null,
                EndDate : this.dateRange?.split(' - ')[1] || null
            }
        },
        c_month(){
            var date = new Date();
            var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
            var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            return [moment(firstDay).format("YYYY-MM-DD"),moment(lastDay).format("YYYY-MM-DD")].join(" - ")
        }
    }
}
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>